import Vue from 'vue'

export default {
    resetStateMutation(state) {
        Vue.set(state, "formIsOpen", false);
        Vue.set(state, "gridIsOpen", true);
    },
    setFormOpenEprofileNemAllergia(state) {
        state.formIsOpen = true;
        state.gridIsOpen = false;
    },
    setFormCloseEprofileNemAllergia(state) {
        state.formIsOpen = false;
        state.gridIsOpen = true;
    }
}
